(function () {
  'use strict';

  var mobileQuery = window.matchMedia('(max-width: 767px)');
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var hintStarted = false;
  var hintObserver;
  var hintArmScrollHandler;
  var hintMarker;
  var hintObservedSlider;
  var mutationObserver;
  var firstImageObserver;
  var secondImageObserver;
  var secondImageQueue = [];
  var activeSecondImageLoads = 0;
  var maxConcurrentSecondImageLoads = 2;

    function hydrateImage(frame) {
    if (!frame || frame.dataset.wcLoaded === 'true') return;
    var image = frame.querySelector('img');
    if (!image) {
      image = document.createElement('img');
      image.className = 'wc-mobile-card-slider__image';
      image.alt = frame.dataset.wcAlt || '';
      image.loading = 'lazy';
      image.draggable = false;
      image.width = Number(frame.dataset.wcWidth) || 0;
      image.height = Number(frame.dataset.wcHeight) || 0;
      image.sizes = '(max-width: 767px) 50vw, 1px';
      frame.appendChild(image);
    }
    if (frame.dataset.wcSrcset) image.srcset = frame.dataset.wcSrcset;
    if (frame.dataset.wcSrc) image.src = frame.dataset.wcSrc;
    frame.dataset.wcLoaded = 'true';
  }

  function hydrateSlide(slider, index) {
    var slides = slider.querySelectorAll('[data-wc-mobile-card-slide]');
    if (index < 0 || index >= slides.length) return;
    hydrateImage(slides[index].querySelector('[data-wc-src]'));
  }

  function observeFirstImage(slider) {
    if (!('IntersectionObserver' in window)) {
      slider.dataset.wcFirstImageObserved = 'true';
      hydrateSlide(slider, 0);
      return;
    }
    if (!firstImageObserver) {
      firstImageObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var observedSlider = entry.target;
          firstImageObserver.unobserve(observedSlider);
          observedSlider.dataset.wcFirstImageObserved = 'true';
          hydrateSlide(observedSlider, 0);
        });
      }, { rootMargin: '300px 0px', threshold: 0.01 });
    }
    firstImageObserver.observe(slider);
  }

  function runWhenIdle(callback) {
    window.setTimeout(function () {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: 500 });
      } else {
        callback();
      }
    }, 150);
  }

  function startSecondImageLoad(image) {
    activeSecondImageLoads += 1;
    image.setAttribute('fetchpriority', 'low');
    var settled = false;
    var finish = function () {
      if (settled) return;
      settled = true;
      activeSecondImageLoads = Math.max(0, activeSecondImageLoads - 1);
      pumpSecondImageQueue();
    };
    image.addEventListener('load', finish, { once: true });
    image.addEventListener('error', finish, { once: true });
    hydrateImage(image);
    if (image.complete) window.setTimeout(finish, 0);
  }

  function pumpSecondImageQueue() {
    while (activeSecondImageLoads < maxConcurrentSecondImageLoads && secondImageQueue.length) {
      var image = secondImageQueue.shift();
      if (!image || image.dataset.wcLoaded === 'true') continue;
      startSecondImageLoad(image);
    }
  }

  function queueSecondImage(slider) {
    if (slider.dataset.wcSecondPreloadQueued === 'true') return;
    var images = slider.querySelectorAll('[data-wc-mobile-card-slide] [data-wc-src]');
    if (images.length < 2) return;

    slider.dataset.wcSecondPreloadQueued = 'true';
    var firstImage = images[0];
    var secondImage = images[1];
    var schedule = function () {
      runWhenIdle(function () {
        if (secondImage.dataset.wcLoaded === 'true') return;
        secondImageQueue.push(secondImage);
        pumpSecondImageQueue();
      });
    };

    if (firstImage.complete && firstImage.naturalWidth > 0) {
      schedule();
    } else {
      firstImage.addEventListener('load', schedule, { once: true });
    }
  }

  function observeSecondImage(slider) {
    if (!('IntersectionObserver' in window)) return;
    if (!secondImageObserver) {
      secondImageObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          secondImageObserver.unobserve(entry.target);
          queueSecondImage(entry.target);
        });
      }, { rootMargin: '150px 0px', threshold: 0.01 });
    }
    secondImageObserver.observe(slider);
  }

  function updateSlider(slider) {
    var track = slider.querySelector('[data-wc-mobile-card-track]');
    var slides = slider.querySelectorAll('[data-wc-mobile-card-slide]');
    var bars = slider.querySelectorAll('[data-wc-mobile-card-bar]');
    if (!track || !slides.length) return;

    var index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(track.clientWidth, 1))));
    slides.forEach(function (slide, slideIndex) {
      var active = slideIndex === index;
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      slide.tabIndex = active ? 0 : -1;
    });
    bars.forEach(function (bar, barIndex) {
      bar.classList.toggle('is-active', barIndex === index);
    });

    if (index > 0 || slider.dataset.wcFirstImageObserved === 'true') hydrateSlide(slider, index);
    if (index >= 1) hydrateSlide(slider, index + 1);
    slider.dataset.wcActiveSlide = String(index);
  }

  function cleanUpHintWatchers() {
    if (hintArmScrollHandler) {
      window.removeEventListener('scroll', hintArmScrollHandler);
      hintArmScrollHandler = null;
    }
    if (hintObserver) {
      hintObserver.disconnect();
      hintObserver = null;
    }
    if (hintMarker && hintMarker.parentNode) hintMarker.parentNode.removeChild(hintMarker);
    hintMarker = null;
  }

  function playHint(firstSlider) {
    if (hintStarted) return;
    hintStarted = true;
    cleanUpHintWatchers();
    hydrateSlide(firstSlider, 1);
    firstSlider.dataset.wcHintPlayed = 'true';
    firstSlider.classList.add('is-hinting');
    firstSlider.addEventListener('animationend', function () {
      firstSlider.classList.remove('is-hinting');
    }, { once: true });
  }

  function observeHint() {
    if (hintStarted || reducedMotionQuery.matches || !mobileQuery.matches) return;
    var firstSlider = document.querySelector('#shopify-section-collection_page [data-wc-mobile-card-slider]');
    if (!firstSlider || hintObservedSlider === firstSlider) return;

    cleanUpHintWatchers();
    hintObservedSlider = firstSlider;
    firstSlider.dataset.wcHintObserved = 'true';
    var initialScrollY = window.pageYOffset;
    var lastScrollY = initialScrollY;

    hintArmScrollHandler = function () {
      var currentScrollY = window.pageYOffset;
      var scrollingDown = currentScrollY > lastScrollY + 1;
      lastScrollY = currentScrollY;
      if (!scrollingDown || currentScrollY < initialScrollY + 8) return;

      window.removeEventListener('scroll', hintArmScrollHandler);
      hintArmScrollHandler = null;
      hintMarker = document.createElement('span');
      hintMarker.setAttribute('aria-hidden', 'true');
      hintMarker.style.cssText = 'position:absolute;top:50%;left:50%;width:1px;height:1px;pointer-events:none;';
      firstSlider.appendChild(hintMarker);

      hintObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) playHint(firstSlider);
        });
      }, { rootMargin: '-47% 0px -47% 0px', threshold: 0 });
      hintObserver.observe(hintMarker);
    };
    window.addEventListener('scroll', hintArmScrollHandler, { passive: true });
  }

  function initSlider(slider) {
    if (!mobileQuery.matches || slider.dataset.wcInitialized === 'true') return;

    var track = slider.querySelector('[data-wc-mobile-card-track]');
    if (!track) return;

    slider.dataset.wcInitialized = 'true';
    slider.dataset.wcActiveSlide = '0';
    observeFirstImage(slider);
    observeSecondImage(slider);

    var startX = 0;
    var startScrollLeft = 0;
    var didSwipe = false;
    var frameRequested = false;

    track.addEventListener('pointerdown', function (event) {
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      didSwipe = false;
      var currentIndex = Number(slider.dataset.wcActiveSlide || 0);
      hydrateSlide(slider, currentIndex + 1);
    }, { passive: true });

    track.addEventListener('pointermove', function (event) {
      if (Math.abs(event.clientX - startX) > 8 || Math.abs(track.scrollLeft - startScrollLeft) > 8) {
        didSwipe = true;
      }
    }, { passive: true });

    track.addEventListener('scroll', function () {
      if (Math.abs(track.scrollLeft - startScrollLeft) > 8) didSwipe = true;
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(function () {
        frameRequested = false;
        updateSlider(slider);
      });
    }, { passive: true });

    slider.addEventListener('click', function (event) {
      if (!event.target.closest('[data-wc-mobile-card-slide]') || !didSwipe) return;
      event.preventDefault();
      event.stopPropagation();
      didSwipe = false;
    }, true);

    updateSlider(slider);
  }

  function initWithin(root) {
    if (!mobileQuery.matches) return;
    var sliders = [];
    if (root.nodeType === 1 && root.matches('[data-wc-mobile-card-slider]')) sliders.push(root);
    if (root.querySelectorAll) {
      sliders = sliders.concat(Array.prototype.slice.call(root.querySelectorAll('[data-wc-mobile-card-slider]')));
    }
    sliders.forEach(initSlider);
    observeHint();
  }

  function start() {
    initWithin(document);
    if (mutationObserver) return;
    mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) initWithin(node);
        });
      });
    });
    mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', function (event) {
      if (event.matches) initWithin(document);
    });
  }
}());
